module.exports = __webpack_public_path__ + "static/media/imac-scrn-seo-copywriting-v2.5502cfc8.jpg";